(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-portal-main"]) return;
  try {
    
class MatrixPortal {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    const dataset = this.container.dataset;
    this.CONFIG = {
      DISCOUNT_PERCENT: parseFloat(dataset.discountPercent) || 5.0,
      DISCOUNT_CODE: dataset.discountCode || 'WH0LES4LE',
      COLLECTION_HANDLE: dataset.collectionHandle || 'all',
      DDP_PRODUCT_HANDLE: dataset.ddpProductHandle,
      DDP_SERVICE_RATES: { 'US': 0.22, 'CA': 0.17, 'GB': 0.26, 'AU': 0.10 }
    };

    this.elements = {
      tableBody: this.container.querySelector('#matrix-table-body'),
      tableWrapper: this.container.querySelector('.matrix-table-wrapper'), // --- FIX A: Elemento necesario para el scroll
      searchInput: this.container.querySelector('#matrix-search'),
      productCount: this.container.querySelector('#product-count'),
      summaryItemCount: this.container.querySelector('#summary-item-count'),
      summarySubtotal: this.container.querySelector('#summary-subtotal'),
      summarySavingsBreakdown: this.container.querySelector('#summary-savings-breakdown'),
      summaryRetailValue: this.container.querySelector('#summary-retail-value'),
      summaryInitialSavings: this.container.querySelector('#summary-initial-savings'),
      summaryWholesaleSavings: this.container.querySelector('#summary-wholesale-savings'),
      summaryTotalSavings: this.container.querySelector('#summary-total-savings'),
      countrySelector: this.container.querySelector('#country-selector'),
      estimatorBreakdown: this.container.querySelector('#estimator-breakdown'),
      summaryForwarder: this.container.querySelector('#summary-forwarder'),
      summaryTotalFob: this.container.querySelector('#summary-total-fob'),
      ddpTotalLine: this.container.querySelector('#ddp-total-line'),
      summaryTotalDdp: this.container.querySelector('#summary-total-ddp'),
      addToCartBtn: this.container.querySelector('#add-to-cart-btn'),
      statusMessage: this.container.querySelector('#order-status-message'),
      orderSummary: this.container.querySelector('#order-summary'),
    };

    this.state = {
      allProducts: [],
      filteredProducts: [],
      cart: {},
      ddpFeeVariantId: null,
      renderedRows: 0,
      rowsToRender: 75
    };
    this.init();
  }

  async init() {
    this.showSkeletonLoader();
    this.loadCartFromStorage();
    if (this.CONFIG.DDP_PRODUCT_HANDLE) {
      await this.fetchDdpVariantId();
    }
    await this.fetchAllProducts();
    this.addEventListeners();
    this.updateSummary();
  }

  async fetchDdpVariantId() {
    try {
      const response = await fetch(`/products/${this.CONFIG.DDP_PRODUCT_HANDLE}.js`);
      if (!response.ok) throw new Error('DDP service product not found in Shopify.');
      const product = await response.json();
      if (product.variants && product.variants.length > 0) {
        this.state.ddpFeeVariantId = product.variants[0].id;
        console.log('DDP Service Variant ID loaded:', this.state.ddpFeeVariantId);
      } else {
        throw new Error('DDP service product has no variants.');
      }
    } catch (error) {
      console.error('CRITICAL DDP ERROR:', error);
      // --- FIX C: Mostrar error visible al usuario si el producto DDP no se carga.
      this.elements.statusMessage.textContent = 'Error: DDP service is unavailable. Please contact support.';
      const countrySelector = this.elements.countrySelector;
      if(countrySelector) {
        countrySelector.disabled = true;
        const errorOption = document.createElement('option');
        errorOption.textContent = 'DDP Service Unavailable';
        countrySelector.innerHTML = '';
        countrySelector.appendChild(errorOption);
      }
    }
  }

  async fetchAllProducts() {
    let page = 1;
    let hasMoreProducts = true;
    const fetchedProducts = [];
    this.elements.productCount.textContent = 'Loading products...';
    const domParser = new DOMParser();

    while(hasMoreProducts) {
      try {
        const response = await fetch(`/collections/${this.CONFIG.COLLECTION_HANDLE}/products.json?limit=250&page=${page}&fields=id,title,handle,vendor,variants,images,body_html`);
        const data = await response.json();
        if (data.products && data.products.length > 0) {
          fetchedProducts.push(...data.products);
          this.elements.productCount.textContent = `Loading ${fetchedProducts.length}...`;
          page++;
        } else {
          hasMoreProducts = false;
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        hasMoreProducts = false;
      }
    }
    
    const allVariants = [];
    fetchedProducts.forEach(product => {
      let creationWatchesStock = 0;
      if (product.body_html) {
        try {
          const doc = domParser.parseFromString(product.body_html, 'text/html');
          const specContainer = doc.querySelector('[data-cw-inventory]');
          if (specContainer) {
            creationWatchesStock = parseInt(specContainer.dataset.cwInventory, 10) || 0;
          }
        } catch (e) {
          console.warn(`Could not parse HTML for product ${product.id}`, e);
        }
      }

      product.variants.forEach(variant => {
        if (variant.available && creationWatchesStock > 0) {
          const imageUrl = variant.featured_image?.src || product.featured_image?.src || product.images[0]?.src || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
          
          allVariants.push({
            id: variant.id,
            title: product.title,
            sku: variant.sku,
            url: product.handle,
            image: imageUrl,
            inventory: creationWatchesStock,
            price: variant.price,
            compare_at_price: variant.compare_at_price
          });
        }
      });
    });

    this.state.allProducts = allVariants;
    this.state.filteredProducts = this.state.allProducts;
    this.elements.productCount.textContent = `${this.state.allProducts.length} products available`;
    this.renderInitialTable();
  }

  addEventListeners() {
    this.elements.searchInput.addEventListener('input', () => this.handleFilter());
    this.elements.tableBody.addEventListener('change', (e) => {
      if (e.target.classList.contains('qty-input')) this.handleQuantityChange(e.target);
    });
    this.elements.countrySelector.addEventListener('change', () => this.updateSummary());
    this.elements.addToCartBtn.addEventListener('click', () => this.handleAddToCart());
    // --- FIX A: Restaurar el event listener para el scroll infinito.
    this.elements.tableWrapper.addEventListener('scroll', () => this.handleScroll());
  }

  renderInitialTable() {
    this.state.renderedRows = 0;
    this.elements.tableBody.innerHTML = '';
    this.loadMoreRows();
  }

  loadMoreRows() {
    const productsToRender = this.state.filteredProducts.slice(this.state.renderedRows, this.state.renderedRows + this.state.rowsToRender);
    if (productsToRender.length === 0 && this.state.renderedRows === 0) {
      this.elements.tableBody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 40px;">No products match your filter.</td></tr>';
      return;
    }
    if (productsToRender.length === 0) return;

    const formatMoney = (value) => `$${(value).toFixed(2)}`;
    let tableHtml = '';
    productsToRender.forEach(p => {
      // --- FIX B: Motor de Precios Inteligente v23.0 ---
      const SANITY_THRESHOLD = 75.00; // Umbral más realista para relojes de lujo.
      let priceInCents = p.price;
      let compareAtPriceInCents = p.compare_at_price;

      if ((priceInCents / 100) < SANITY_THRESHOLD && priceInCents > 0) {
        priceInCents *= 100;
        if (compareAtPriceInCents) {
          compareAtPriceInCents *= 100;
        }
      }

      const originalComparePrice = compareAtPriceInCents ? compareAtPriceInCents / 100 : null;
      const productSalePrice = priceInCents / 100;
      const wholesaleComparePrice = productSalePrice;
      const finalWholesalePrice = wholesaleComparePrice * (1 - this.CONFIG.DISCOUNT_PERCENT / 100);
      
      const highestOriginalPrice = Math.max(originalComparePrice || 0, productSalePrice);
      const totalSavings = highestOriginalPrice - finalWholesalePrice;
      
      let savingsHTML = '';
      if (totalSavings > 0.01) {
        const initialSavings = highestOriginalPrice - productSalePrice;
        const wholesaleOnlySavings = productSalePrice - finalWholesalePrice;
        
        let breakdown = [];
        if (initialSavings > 0.01) {
          const initialPercent = ((initialSavings / highestOriginalPrice) * 100).toFixed(0);
          breakdown.push(`Retail Save: ${formatMoney(initialSavings)} (${initialPercent}%)`);
        }
        breakdown.push(`+ Your 5% Off: ${formatMoney(wholesaleOnlySavings)}`);
        
        savingsHTML = `
          <div class="savings-breakdown">
            ${breakdown.join('<br>')}
            <div class="total-save">Total Save: ${formatMoney(totalSavings)}</div>
          </div>
        `;
      }

      const stock = p.inventory;
      const stockLevel = stock > 10 ? 'high' : 'low';
      let stockText = `${stock} units left`;
      if (stock <= 5) {
        stockText = `Low stock: ${stock} left`;
      }
      const maxQtyAttribute = `max="${stock}"`;
      const currentQty = this.state.cart[p.id] || '';
      
      tableHtml += `
        <tr data-variant-id="${p.id}">
          <td class="col-image"><img src="${p.image}" alt="${p.title}" class="product-image" loading="lazy"></td>
          <td class="col-product"><div class="product-title">${p.title}</div></td>
          <td class="col-sku">${p.sku}</td>
          <td class="col-stock"><span class="inventory-dot ${stockLevel}"></span>${stockText}</td>
          <td class="col-price">
            <div class="wholesale-price">${formatMoney(finalWholesalePrice)}</div>
            <div class="wholesale-compare-price">Retail Price: ${formatMoney(wholesaleComparePrice)}</div>
            ${savingsHTML}
          </td>
          <td class="col-details"><a href="/products/${p.url}" class="details-link" target="_blank">View</a></td>
          <td class="col-qty"><input type="number" class="input qty-input" min="0" ${maxQtyAttribute} placeholder="0" value="${currentQty}" data-variant-id="${p.id}" aria-label="Quantity for ${p.title}"></td>
        </tr>
      `;
    });
    this.elements.tableBody.insertAdjacentHTML('beforeend', tableHtml);
    this.state.renderedRows += productsToRender.length;
  }

  // --- FIX A: Restaurar la función handleScroll.
  handleScroll() {
    const { scrollTop, scrollHeight, clientHeight } = this.elements.tableWrapper;
    if (scrollHeight - scrollTop - clientHeight < 400) {
      this.loadMoreRows();
    }
  }

  handleQuantityChange(input) {
    const variantId = input.dataset.variantId;
    const maxStock = parseInt(input.max, 10);
    let quantity = parseInt(input.value, 10);

    if (isNaN(quantity) || quantity <= 0) {
      delete this.state.cart[variantId];
      input.value = '';
    } else if (!isNaN(maxStock) && quantity > maxStock) {
      quantity = maxStock;
      input.value = maxStock;
      this.state.cart[variantId] = quantity;
    } else {
      this.state.cart[variantId] = quantity;
    }
    this.updateSummary();
    this.saveCartToStorage();
  }

  updateSummary() {
    const formatMoney = (value) => `$${value.toFixed(2)}`;
    let subtotal = 0;
    let itemCount = 0;
    let totalRetailValue = 0;

    for (const variantId in this.state.cart) {
      const product = this.state.allProducts.find(p => p.id == variantId);
      if (product) {
        const quantity = this.state.cart[variantId];
        
        let priceInCents = product.price;
        let compareAtPriceInCents = product.compare_at_price;
        const SANITY_THRESHOLD = 75.00; // --- FIX B: Usar el mismo umbral aquí.
        if ((priceInCents / 100) < SANITY_THRESHOLD && priceInCents > 0) {
          priceInCents *= 100;
          if (compareAtPriceInCents) compareAtPriceInCents *= 100;
        }

        const productSalePrice = priceInCents / 100;
        const originalComparePrice = compareAtPriceInCents ? compareAtPriceInCents / 100 : productSalePrice;
        const highestOriginalPrice = Math.max(originalComparePrice, productSalePrice);

        subtotal += productSalePrice * quantity;
        itemCount += quantity;
        totalRetailValue += highestOriginalPrice * quantity;
      }
    }

    const wholesaleDiscountAmount = subtotal * (this.CONFIG.DISCOUNT_PERCENT / 100);
    const finalSubtotal = subtotal - wholesaleDiscountAmount;
    const initialSavings = totalRetailValue - subtotal;
    const totalSavings = totalRetailValue - finalSubtotal;

    this.elements.summaryItemCount.textContent = itemCount;
    this.elements.summarySubtotal.textContent = formatMoney(subtotal);

    if (totalSavings > 0.01) {
      this.elements.summarySavingsBreakdown.classList.remove('hidden');
      this.elements.summaryRetailValue.textContent = formatMoney(totalRetailValue);
      this.elements.summaryInitialSavings.textContent = `-${formatMoney(initialSavings)}`;
      this.elements.summaryWholesaleSavings.textContent = `-${formatMoney(wholesaleDiscountAmount)}`;
      this.elements.summaryTotalSavings.textContent = formatMoney(totalSavings);
    } else {
      this.elements.summarySavingsBreakdown.classList.add('hidden');
    }

    this.elements.summaryTotalFob.textContent = formatMoney(finalSubtotal);
    const selectedCountry = this.elements.countrySelector.value;
    
    if (selectedCountry && finalSubtotal > 0) {
      const serviceRate = this.CONFIG.DDP_SERVICE_RATES[selectedCountry] || 0;
      const serviceFee = finalSubtotal * serviceRate;
      const ddpTotal = finalSubtotal + serviceFee;

      this.elements.estimatorBreakdown.classList.remove('hidden');
      this.elements.summaryForwarder.textContent = formatMoney(serviceFee);
      this.elements.ddpTotalLine.classList.remove('hidden');
      this.elements.summaryTotalDdp.textContent = formatMoney(ddpTotal);
    } else {
      this.elements.estimatorBreakdown.classList.add('hidden');
      this.elements.ddpTotalLine.classList.add('hidden');
    }

    this.elements.addToCartBtn.disabled = finalSubtotal <= 0;
    this.elements.orderSummary.classList.add('summary-flash');
    setTimeout(() => this.elements.orderSummary.classList.remove('summary-flash'), 700);
  }

  handleFilter() {
    const searchTerm = this.elements.searchInput.value.toLowerCase();
    this.state.filteredProducts = this.state.allProducts.filter(p => 
      (p.title && p.title.toLowerCase().includes(searchTerm)) || 
      (p.sku && p.sku.toLowerCase().includes(searchTerm))
    );
    this.renderInitialTable();
  }

  async handleAddToCart() {
    this.elements.addToCartBtn.disabled = true;
    this.elements.addToCartBtn.textContent = 'Processing...';
    this.elements.statusMessage.textContent = '';

    const items = Object.entries(this.state.cart).map(([id, quantity]) => ({ id: parseInt(id), quantity }));

    if (items.length === 0) {
      this.elements.addToCartBtn.textContent = 'Add to Cart & Checkout';
      return;
    }

    const selectedCountry = this.elements.countrySelector.value;
    // --- FIX C: Lógica de DDP blindada.
    if (selectedCountry && this.state.ddpFeeVariantId) {
      let subtotal = 0;
      for (const variantId in this.state.cart) {
          const product = this.state.allProducts.find(p => p.id == variantId);
          if (product) {
              let priceInCents = product.price;
              const SANITY_THRESHOLD = 75.00; // --- FIX B: Usar el mismo umbral aquí.
              if ((priceInCents / 100) < SANITY_THRESHOLD && priceInCents > 0) priceInCents *= 100;
              subtotal += (priceInCents / 100) * this.state.cart[variantId];
          }
      }
      const wholesaleDiscountAmount = subtotal * (this.CONFIG.DISCOUNT_PERCENT / 100);
      const finalSubtotal = subtotal - wholesaleDiscountAmount;
      const serviceRate = this.CONFIG.DDP_SERVICE_RATES[selectedCountry] || 0;
      const serviceFee = finalSubtotal * serviceRate;

      if (serviceFee > 0) {
        const feeQuantity = Math.round(serviceFee);
        if (feeQuantity > 0) {
            items.push({ id: this.state.ddpFeeVariantId, quantity: feeQuantity });
        }
      }
    }

    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Could not add items to cart.');
      }
      
      this.clearCartFromStorage();
      
      const checkoutUrl = new URL(window.location.origin + '/checkout');
      checkoutUrl.searchParams.append('discount', this.CONFIG.DISCOUNT_CODE);
      window.location.href = checkoutUrl.toString();

    } catch (error) {
      this.elements.statusMessage.textContent = `Error: ${error.message}`;
      this.elements.addToCartBtn.disabled = false;
      this.elements.addToCartBtn.textContent = 'Add to Cart & Checkout';
    }
  }

  saveCartToStorage() {
    localStorage.setItem('wholesaleCart', JSON.stringify(this.state.cart));
  }

  loadCartFromStorage() {
    const savedCart = localStorage.getItem('wholesaleCart');
    if (savedCart) {
      this.state.cart = JSON.parse(savedCart);
    }
  }

  clearCartFromStorage() {
    localStorage.removeItem('wholesaleCart');
  }

  showSkeletonLoader() {
    let skeletonHtml = '';
    for (let i = 0; i < 15; i++) {
      skeletonHtml += `
        <tr class="skeleton-row">
          <td><div class="skeleton-loader" style="width: 45px; height: 45px;"></div></td>
          <td><div class="skeleton-loader" style="width: 80%; height: 20px;"></div></td>
          <td><div class="skeleton-loader" style="width: 60%; height: 20px;"></div></td>
          <td><div class="skeleton-loader" style="width: 70%; height: 20px;"></div></td>
          <td><div class="skeleton-loader" style="width: 50%; height: 20px;"></div></td>
          <td><div class="skeleton-loader" style="width: 40px; height: 20px;"></div></td>
          <td><div class="skeleton-loader" style="width: 70px; height: 36px;"></div></td>
        </tr>
      `;
    }
    this.elements.tableBody.innerHTML = skeletonHtml;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const portalContainer = document.querySelector('.matrix-portal-container');
  if (portalContainer) {
    new MatrixPortal(portalContainer);
  }
});

  } catch(e) { console.error(e); }
})();
})();
